<template>
    <div>
        <zm-row>
            <zm-dropdown style="margin: 10px;" @command="handleTopicCommand" v-if="hasRequestPermission" trigger="click">
                <zm-button size="small" type="primary" plain>Topic Requests<i class="zm-icon-down"></i></zm-button>
                <zm-dropdown-menu slot="dropdown">
                    <zm-dropdown-item command="createTopic">Create Topic</zm-dropdown-item>
                    <zm-dropdown-item command="createTopics">Create Topics</zm-dropdown-item>
                    <zm-dropdown-item command="editTopic">Edit Topic</zm-dropdown-item>
                    <zm-dropdown-item command="editPrivileges">Edit Topic Privileges</zm-dropdown-item>
                </zm-dropdown-menu>
            </zm-dropdown>
            <zm-dropdown style="margin: 10px;" @command="handleUserCommand" v-if="hasRequestPermission" trigger="click">
                <zm-button size="small" type="primary" plain>User Requests<i class="zm-icon-down"></i></zm-button>
                <zm-dropdown-menu slot="dropdown">
                    <zm-dropdown-item command="createUser">Create User</zm-dropdown-item>
                    <zm-dropdown-item command="editUser">Edit User</zm-dropdown-item>
                </zm-dropdown-menu>
            </zm-dropdown>
            <zm-button v-if="requestIds.length && status=='CREATED'" @click="submitRequest()" class="btn-in-line" type="primary">Submit Requests</zm-button>
            <zm-button v-if="requestIds.length && status=='SUBMITTED'" @click="approveRequest()" class="btn-in-line" type="primary">Approve Requests</zm-button>
            <zm-button v-if="requestIds.length && status=='APPROVED'" @click="executeRequest()" class="btn-in-line" type="primary">Execute Requests</zm-button>
            <!-- <zm-button size="small" @click="showCreateTopic()" class="btn-in-line" type="primary">create request topic</zm-button>
            <zm-button size="small" @click="batch()" class="btn-in-line" type="primary">batch create request topics</zm-button> -->
            <zm-select size="small" v-model="status" class="status-select" @change="fetchData()" clearable>
                <zm-option label="CREATED" value="CREATED"></zm-option>
                <zm-option label="SUBMITTED" value="SUBMITTED"></zm-option>
                <zm-option label="APPROVED" value="APPROVED"></zm-option>
                <zm-option label="EXECUTED" value="EXECUTED"></zm-option>
                <zm-option label="REJECTED" value="REJECTED"></zm-option>
                <zm-option label="FAILED" value="FAILED"></zm-option>
            </zm-select>
        </zm-row>
        <div class="table-container">
            <zm-table resizable border @sort-change="onSort" :init-displayed-column="initDisplayedColumn"
                :data="list" v-loading="loading" :row-class-name="tableRowClassName" @selection-change="handleSelectRows">
                <zm-table-column v-if="status==='CREATED'||status==='SUBMITTED'||status==='APPROVED'" type="selection" width="40"></zm-table-column>
                <zm-table-column prop="name" label="Name" align="left" :show-overflow-tooltip="true" sortable>
                </zm-table-column>
                <zm-table-column prop="type" label="Type" align="center" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column prop="createdUser" label="createdUser" align="center" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column prop="submittedUser" label="submittedUser" align="center" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column prop="approvedUser" label="approvedUser" align="center" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column prop="executedUser" label="executedUser" align="center" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column prop="lastEditUser" label="lastEditUser" align="center" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column prop="status" label="status" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <tip :label="scope.row.status"
                        :tips="scope.row.message" v-if="scope.row.status === 'REJECTED' || scope.row.status === 'FAILED'"></tip>
                        <span v-else>{{ scope.row.status }}</span>
                    </template>
                </zm-table-column>
                <zm-table-column prop="createdTime" width="210px" label="createdTime" align="center" :formatter="setTime" sortable>
                </zm-table-column>
                <zm-table-column prop="modifiedTime" width="210px" label="modifiedTime" align="center" :formatter="setTime" sortable>
                </zm-table-column>
                <zm-table-column prop="operate" label="operate" width="150px" header-align="center">
                    <template slot-scope="scope">
                        <div>
                            <zm-button size="small" class="btn-contain" type="icon" title="edit request" icon="zm-icon-edit"
                            @click="showEdit(scope.row)" :disabled="scope.row.status === 'EXECUTED'"></zm-button>
                            <zm-dropdown class="btn-contain" style="margin-left: 10px;" @command="handleCommand" v-if="scope.row.status !== 'EXECUTED' && scope.row.status !== 'REJECTED' && scope.row.status !== 'FAILED'">
                                <zm-button type="icon" icon="zm-icon-move-to" class="btn-contain" :loading="scope.row.rowLoading"></zm-button>
                                <zm-dropdown-menu slot="dropdown">
                                    <zm-dropdown-item :command="{command: 'submitRequest', param: scope.row.id}" v-if="scope.row.status === 'CREATED'">
                                        Submit Request
                                    </zm-dropdown-item>
                                    <zm-dropdown-item :command="{command: 'approveRequest', param: scope.row.id}" v-if="scope.row.status === 'SUBMITTED'">
                                        Approve Request
                                    </zm-dropdown-item>
                                    <zm-dropdown-item :command="{command: 'executeRequest', param: scope.row.id}" v-if="scope.row.status === 'APPROVED'">
                                        Execute Request
                                    </zm-dropdown-item>
                                    <zm-dropdown-item :command="{command: 'rejectRequest', param: scope.row}" v-if="scope.row.status !== 'EXECUTED' && scope.row.status !== 'REJECTED' && scope.row.status !== 'FAILED'">
                                        Reject Request
                                    </zm-dropdown-item>
                                </zm-dropdown-menu>
                            </zm-dropdown>
                            <!-- <zm-button size="small" class="btn-contain" type="icon" title="submit request" icon="zm-icon-forward"
                            v-if="scope.row.status === 'CREATED'" @click="submitRequest(scope.row.id)"></zm-button>
                            <zm-button size="small" class="btn-contain" type="icon" title="approve request" icon="zm-icon-forward"
                            v-if="scope.row.status === 'SUBMITTED'" @click="approveRequest(scope.row.id)"></zm-button>
                            <zm-button size="small" class="btn-contain" type="icon" title="execute request" icon="zm-icon-forward"
                            v-if="scope.row.status === 'APPROVED'" @click="executeRequest(scope.row.id)"></zm-button> -->
                            <zm-button size="small" class="btn-contain" type="icon" title="delete request" icon="zm-icon-delete" style="margin-left: 10px"
                            @click="deleteRequest(scope.row)"></zm-button>
                        </div>
                    </template>
                </zm-table-column>
            </zm-table>
            <div style="text-align: center" class="pagination-wrap">
                <zm-pagination @current-change="fetchData"
                    @size-change="handleSizeChange"
                    :current-page.sync="pageable.page" :page-size="pageable.size"
                    :page-sizes="[10, 20, 50, 100, 500, 1000]"
                    layout="sizes, total, prev, pager, next"
                    :total="pageable.total">
                </zm-pagination>
            </div>
        </div>
        <create-topic ref="createTopic" :row="selectedRequest" @refreshRequest="fetchData" :isCreate="isCreateTopic"></create-topic>
        <create-user ref="createUser" :row="selectedRequest" @refreshRequest="fetchData" :isCreate="isCreateUser"></create-user>
        <batch-create ref="batchCreate" :isRequestTopic="true" @refreshRequest="fetchData"></batch-create>
        <privilege ref="privilege" :row="selectedRequest" @refreshRequest="fetchData"></privilege>
    </div>
</template>
<script>
import {
    approveRequest,
    approveRequests,
    deleteRequest,
    executeRequest,
    executeRequests,
    getRequestList,
    rejectRequest,
    submitRequest,
    submitRequests
} from '../../api/request'
import createTopic from './createTopic'
import createUser from './createUser'
import batchCreate from './batchCreate'
import privilege from './privilege'
import tip from 'components/ToolTip/index'
export default {
    name: 'requestTopic',
    components: {
        tip,
        batchCreate,
        createTopic,
        createUser,
        privilege
    },
    data () {
        return {
            role: localStorage.role,
            hasRequestPermission: localStorage.role !== 'READONLY',
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            initDisplayedColumn: {
                key: 'requestTopic',
                props: ['name', 'type', 'status', 'modifiedTime', 'operate']
            },
            list: [],
            loading: false,
            pageable: {
                page: 1,
                size: 10,
                total: 0
            },
            selectedRequest: null,
            status: '',
            isCreateTopic: true,
            isCreateUser: true,
            requestIds: []
        }
    },
    created () {
        if (localStorage.params && localStorage.params !== 'undefined' && localStorage.path === this.$route.path) {
            this.status = JSON.parse(localStorage.params).status
            this.pageable.page = JSON.parse(localStorage.params).page
            this.pageable.size = JSON.parse(localStorage.params).size
            this.fetchData()
        } else {
            this.fetchData()
        }
        localStorage.params = ''
        localStorage.path = this.$route.path
        // this.fetchChannels()
    },
    watch: {
        status () {
            this.setURL()
        },
        'pageable.page' () {
            this.setURL()
        },
        'pageable.size' () {
            this.setURL()
        }
    },
    methods: {
        setURL () {
            const { status } = this
            const { page, size } = this.pageable
            const data = { path: this.$route.path, status, page, size }
            localStorage.params = JSON.stringify(data)
        },
        trimLR () {
            this.form.name = this.form.name.replace(/\s+/g, '')
        },
        onSort ({ column, prop, order }) {
            const descending = order === 'descending'
            this.list.sort((a, b) => {
                if (a[prop] > b[prop]) {
                    return descending ? -1 : 1
                } else if (a[prop] < b[prop]) {
                    return descending ? 1 : -1
                } else {
                    return 0
                }
            })
        },
        fetchData () {
            this.loading = true
            getRequestList(this.pageable.size, this.pageable.page - 1, this.status).then(response => {
                const { content, pageable: { page, size }, total } = response
                this.list = content.map(item => {
                    const data = item
                    data.rowLoading = false
                    return data
                })
                this.pageable.total = total
                this.pageable.page = page + 1
                this.pageable.size = size
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        handleSizeChange (val) {
            this.pageable.size = val
            this.fetchData()
        },
        submitRequest (id) {
            this.loading = true
            this.$confirm('This will change the status to SUBMITTED. Continue?', 'Warning', {
                confirmButtonText: 'Change',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                if (id) {
                    submitRequest(id).then(response => {
                        this.fetchData()
                        this.$message({
                            message: 'Change status success!',
                            type: 'success'
                        })
                    }).catch(() => {
                        this.loading = false
                    })
                } else {
                    submitRequests(this.requestIds).then(response => {
                        this.fetchData()
                        this.$message({
                            message: 'Change status success!',
                            type: 'success'
                        })
                    }).catch(() => {
                        this.loading = false
                    })
                }
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Change canceled'
                })
            })
        },
        approveRequest (id) {
            this.loading = true
            this.$confirm('This will change the status to APPROVED. Continue?', 'Warning', {
                confirmButtonText: 'Change',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                if (id) {
                    approveRequest(id).then(response => {
                        this.fetchData()
                        this.$message({
                            message: 'Change status success!',
                            type: 'success'
                        })
                    }).catch(() => {
                        this.loading = false
                    })
                } else {
                    approveRequests(this.requestIds).then(response => {
                        this.fetchData()
                        this.$message({
                            message: 'Change status success!',
                            type: 'success'
                        })
                    }).catch(() => {
                        this.loading = false
                    })
                }
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Change canceled'
                })
            })
        },
        executeRequest (id) {
            this.loading = true
            this.$confirm('This will change the status to EXECUTED. Continue?', 'Warning', {
                confirmButtonText: 'Change',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                if (id) {
                    executeRequest(id).then(response => {
                        this.fetchData()
                        this.$message({
                            message: 'Change status success!',
                            type: 'success'
                        })
                    }).catch(() => {
                        this.loading = false
                    })
                } else {
                    executeRequests(this.requestIds).then(response => {
                        this.fetchData()
                        this.$message({
                            message: 'Change status success!',
                            type: 'success'
                        })
                    }).catch(() => {
                        this.loading = false
                    })
                }
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Change canceled'
                })
            })
        },
        deleteRequest (row) {
            this.$confirm('This will delete the topic. Continue?', 'Deleting ' + row.name, {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteRequest(row.id).then(response => {
                    this.loading = false
                    this.fetchData()
                    this.$message({
                        message: 'Delete topic success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        rejectRequest (row) {
            this.$prompt('Please input reason of rejection', 'Reject Request', {
                confirmButtonText: 'Submit',
                cancelButtonText: 'Cancel',
                inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
                inputErrorMessage: 'Please input reason'
            }).then(({ value }) => {
                row.rowLoading = true
                rejectRequest(row.id, value).then(() => {
                    row.rowLoading = false
                    this.$message.success('Reject success')
                    this.fetchData()
                }).catch(() => {
                    row.rowLoading = false
                })
            }).catch(() => {
                this.$message.info('Reject canceled')
            })
        },
        tableRowClassName ({ row, rowIndex }) {
            if (row.status === 'REJECTED' || row.status === 'FAILED') {
                return 'warning-row'
            }
            return ''
        },
        handleCommand (command) {
            if (command.command === 'submitRequest') {
                this.submitRequest(command.param)
            } else if (command.command === 'approveRequest') {
                this.approveRequest(command.param)
            } else if (command.command === 'executeRequest') {
                this.executeRequest(command.param)
            } else if (command.command === 'rejectRequest') {
                this.rejectRequest(command.param)
            }
        },
        setTime (row, column, cellValue, index) {
            let time = row[column.property] || ''
            return new Date(parseInt(time)).toLocaleString()
        },
        showEdit (row) {
            if (row.type === 'CREATE_TOPIC') {
                this.selectedRequest = row
                this.isCreateTopic = true
                this.$refs.createTopic.visible = true
            } else if (row.type === 'EDIT_TOPIC') {
                this.selectedRequest = row
                this.isCreateTopic = false
                this.$refs.createTopic.visible = true
            } else if (row.type === 'CREATE_TOPICS') {
                this.selectedRequest = row
                this.$refs.batchCreate.visible = true
            } else if (row.type === 'EDIT_TOPIC_PRIVILEGES') {
                this.selectedRequest = row
                this.$refs.privilege.visible = true
            } else if (row.type === 'CREATE_USER') {
                this.selectedRequest = row
                this.isCreateUser = true
                this.$refs.createUser.visible = true
            } else if (row.type === 'EDIT_USER') {
                this.selectedRequest = row
                this.isCreateUser = false
                this.$refs.createUser.visible = true
            }
        },
        showCreateTopic () {
            this.selectedRequest = null
            this.isCreateTopic = true
            this.$refs.createTopic.visible = true
        },
        showEditTopic () {
            this.selectedRequest = null
            this.isCreateTopic = false
            this.$refs.createTopic.visible = true
        },
        showEditPrivileges () {
            this.selectedRequest = null
            this.$refs.privilege.visible = true
        },
        showCreateUser () {
            this.selectedRequest = null
            this.isCreateUser = true
            this.$refs.createUser.visible = true
        },
        showEditUser () {
            this.selectedRequest = null
            this.isCreateUser = false
            this.$refs.createUser.visible = true
        },
        batch () {
            this.$refs.batchCreate.visible = true
        },
        handleTopicCommand (command) {
            if (command === 'createTopics') {
                this.$refs.batchCreate.visible = true
            } else if (command === 'createTopic') {
                this.showCreateTopic()
            } else if (command === 'editTopic') {
                this.showEditTopic()
            } else if (command === 'editPrivileges') {
                this.showEditPrivileges()
            }
        },
        handleUserCommand (command) {
            if (command === 'createUser') {
                this.showCreateUser()
            } else if (command === 'editUser') {
                this.showEditUser()
            }
        },
        handleSelectRows (val) {
            this.requestIds = []
            val.map(item => {
                this.requestIds.push(item.id)
            })
        }
    }
}
</script>
<style scoped>
.status-select {
    float: right;
    margin: 10px;
    width: 200px;
}
.user-privilege {
    display: inline-block;
    text-align: center;
    width: 100%;
}
.search-app-input {
    width: 80%;
    margin: 0 10px;
}
</style>
<style>
.number-with-select .zm-input__inner {
    border-radius: 8px 0 0 8px;
}
.select-with-number {
    width: 110px;
}
.select-with-number .zm-select-input {
    border-radius: 0 8px 8px 0;
}
.select-with-number.zm-select {
    border-radius: 0 8px 8px 0;
}
.tag-with-number {
    width: 110px;
    border-radius: 0 8px 8px 0;
}
</style>
